import React, { useState, useEffect } from 'react';
import { OverviewComponent } from './component/OverviewComponent';
import SalesSummaryComponent from './component/SalesSummaryComponent';
import CustomerStatsComponent from './component/CustomerStatsComponent';
import FeaturedItemsComponent from './component/FeaturedItemsComponent';
import MostPopularItemsComponent from './component/MostPopularItemsComponent';
import { useSelector, useDispatch } from 'react-redux';
import { getDashboardService } from '@/services/DashboardServices';
import validationErrors from '@/lib/validationErrors';
import PermissionCheck from '@/components/common/PermissionCheck';

const Dashboard = (props) => {
    const { isAuthenticated, userData } = useSelector((state) => state?.Auth);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);

    useEffect(() => {
        getDashboardData();
    }, []);

    const getDashboardData = () => {
        setIsLoading(true);
        dispatch(getDashboardService())
            .then((res) => {
                setDataSource(res?.data?.data);
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    return (
        <>
            <div className="mb-8">
                <h3 className="font-semibold text-[26px] leading-10 capitalize text-primary">Good Evening!</h3>
                <h4 className="font-medium text-[22px] leading-[34px] capitalize">{userData?.name}</h4>
            </div>
            <PermissionCheck permsission={'view_dashboard'}>
                <OverviewComponent />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <SalesSummaryComponent />
                    <CustomerStatsComponent />
                    <FeaturedItemsComponent dataSource={dataSource} />
                    <MostPopularItemsComponent dataSource={dataSource} />
                </div>
            </PermissionCheck>
        </>
    );
};

export default Dashboard;
